import React, { useState, useEffect } from 'react';
import { randers3data } from '../../../../../Services/SystemSettings/SystemServices';

function S3() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const key = 'S3';
        const responseData = await randers3data(key);
        setData(responseData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (key, value) => {
    setData(prevData => {
      const newData = prevData.map(item => {
        if (item.key === key) {
          return { ...item, value };
        }
        return item;
      });
      return newData;
    });
  };

  return (
    <div id="s3div">
      <form className="row g-3">
        <div className="col-12">
          <label htmlFor="accessKeyId" className="form-label">Access Key Id</label>
          <input
            type="text"
            className="form-control"
            id="accessKeyId"
            name='accessKeyId'
            value={data?.find(item => item.key === 'accessKeyId')?.value || ''}
            onChange={(e) => handleInputChange('accessKeyId', e.target.value)}
          />
          <div className={`gst-err-accessKeyId invalid-feedback`}>Please provide GST number.</div>
        </div>
        <div className="col-12">
          <label htmlFor="secretAccessKey" className="form-label">Secret Access Key</label>
          <input
            type="text"
            className="form-control"
            id="secretAccessKey"
            name='secretAccessKey'
            value={data?.find(item => item.key === 'secretAccessKey')?.value || ''}
            onChange={(e) => handleInputChange('accessKeyId', e.target.value)}
          />
          <div className={`gst-err-secretAccessKey invalid-feedback`}>Please provide Secret Access Key.</div>
        </div>
        <div className="col-12">
          <label htmlFor="region" className="form-label">Region</label>
          <input
            type="text"
            className="form-control"
            id="region"
            name='region'
            value={data?.find(item => item.key === 'region')?.value || ''}
            onChange={(e) => handleInputChange('region', e.target.value)}
          />
          <div className={`gst-err-region invalid-feedback`}>Please provide Region.</div>
        </div>
        <div className="col-12">
          <label htmlFor="bucketname" className="form-label">Bucket Name</label>
          <input
            type="text"
            className="form-control"
            id="bucketname"
            name='bucketname'
            value={data?.find(item => item.key === 'bucketname')?.value || ''}
            onChange={(e) => handleInputChange('bucketname', e.target.value)}
          />
          <div className={`gst-err-bucketname invalid-feedback`}>Please provide Bucket Name.</div>
        </div>
        <div className="text-center">
          <button type="Update" id="gstupdate" className="btn btn-primary">Update</button>
          <button type="Reset" className="btn btn-secondary">Reset</button>
        </div>
      </form>
    </div>
  );
}

export default S3;